import Loadable from '../../components/loadable';

const SequencePage = Loadable({
  loader: () => import('../../pages/sequences/sequence'),
  type: 'block',
});

angular.module('gym').value('SequencePage', SequencePage);
